import React, { useEffect, useState } from 'react';
import { ReactComponent as LogoIcon } from '../assets/Logo.svg';
import { Link } from 'react-router-dom';
import { css } from '@emotion/react';
import { ThemeProvider, Grid, Card } from "@mui/material";
import theme from "styles/motoTheme";
import MotoProvider from '../pages/inspection-momo/context';
import "../pages/inspection-momo/moto.css"
import { useThemeContext } from 'contexts/ThemeContext';
import { makeStyles } from "@mui/styles";

const headerStyle = () => css`
 z-index: 1;
  position: relative;
  background-size: 100%;
  top: 0;
  padding: 0 10px 0 10px;
  background-color: transparent;
  font-weight: 700;

  & > nav {
    height: 100%;
    display: flex;
    margin: 0px 0px;
    max-width: 480px;
    align-items: center;
    justify-content: flex-start;
    .boxLeft{
			width: 20%;
			display: flex;
			margin-left: 0px;
			justify-content: flex-start;
		}
		.boxRight{
			width: 80%;
			display: flex;
			margin: 0px;
			align-items: center;
			justify-content: flex-end;
		}
	
    .logo1 a {
      height: 100%;
      display: flex;
      align-items: flex-start;
	margin-left: 0px !important;

      svg {
        width: 100%;
        height: 32px;
      }
    }
  }
`;
const useStyles = makeStyles((theme) => ({
    headerBgCus: ({ color }) => {
        return {
            maxWidth: '480px',
            width: '100%',
            position: 'fixed',
            top: 0,
            backgroundColor: color,
            height: "50%",
            WebkitMaskImage: '-webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)))',
            maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0))',
        }
    },
}));
const AppLayout = ({ children }) => {
    const { mainColor, textColor } = useThemeContext();
    const classes = useStyles({ color: mainColor });
    return (
        <ThemeProvider theme={theme({ mainColor, textColor })}>
            <MotoProvider>
                <div className={classes.headerBgCus}></div>
                <header css={[headerStyle()]}>
                    <nav style={{ width: "100%" }}>
                        <div className={"boxLeft"}>
                            <div className="logo1">
                                <Link to="/" replace={location.pathname === '/'}>
                                    <LogoIcon fill={textColor} />
                                </Link>
                            </div>
                        </div>
                    </nav>
                </header>
                <div style={{ position: 'relative' }}>
                    <main>
                        <Grid container spacing={1} className={"content"} style={{ height: '90vh' }}>
                            <Grid item xs={12} sm={12} md={12}>
                                {children}
                            </Grid>
                        </Grid>
                    </main>
                </div>

            </MotoProvider>
        </ThemeProvider>
    );
};

export default AppLayout;
